import React from "react";
import "../Footer/Footer.css";
import { Link } from "react-router-dom";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-section">
          <h2 className="logo">Nursery</h2>
          <p className="footer-text">
            Discover the joy of nurturing greenery with our vibrant nursery
            plants. From air-purifying indoor plants to colorful blooms, we
            bring nature closer to your home.Let's grow together and create a
            greener future!
          </p>

          <div className="social-icons">
            <a href="#" className="social-link">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="#" className="social-link">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" className="social-link">
              <i className="fab fa-google-plus-g"></i>
            </a>
            <a href="#" className="social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#" className="social-link">
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h3 className="footer-title">QUICK LINK</h3>
          <ul className="footer-links">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/aboutus">About</Link>
            </li>
            <li>
              <Link to="/servicesmain">Services</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3 className="footer-title">BEST SELLER</h3>
          <div className="product">
            <img
              src="/o4.webp"
              alt="Cactus Flower"
              className="product-imagee"
            />
            <div>
              <p className="p-p">Money Plant</p>
              <p className="price">₹500</p>
            </div>
          </div>
          <div className="product">
            <img src="/h2.webp" alt="Tulip Flower" className="product-imagee" />
            <div>
              <p className="p-p">Indoor Plants</p>
              <p className="price">₹550</p>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <h3 className="footer-title">CONTACT</h3>
          <p>Address: New Delhi, India</p>
          <p>Phone: +91 0000000000</p>
          <p>Email: info.xyz@gmail.com</p>
          <p>Open hours: Mon - Sun: 8 AM to 9 PM</p>
          <p>Happy hours: Sat: 2 PM to 4 PM</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          © Copyright Nursery {currentYear} | All rights reserved | Designed by{" "}
          <a
            className="f-l"
            href="https://infogainsoft.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Infogainsoft
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
